"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaBannerDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../../../api");
var _useTranslations = require("../../../../hooks/useTranslations");
var _net = require("../../../../models/graphql-types/net");
var _utils = require("../../utils");
var _Contact = require("../Contact");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const emphasis = testId => chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
  "data-testid": testId,
  children: chunks
});

/**
 * SharingConditionsDialog component is used to render Dialog in How it works module. This dialog contains the sharing conditions.
 */
const TopAreaBannerDialog = ({
  open,
  onClose
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    data,
    isLoading
  } = (0, _api.usePersonalBeautyStoreData)(open);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    contacts,
    referralProgram,
    photoUrl
  } = data?.beautyStore?.profile ?? {};
  const {
    allowedContacts,
    benefitsLink,
    greetingMessage,
    message,
    title
  } = referralProgram ?? {};
  const {
    relativeUrl,
    title: linkTitle
  } = benefitsLink ?? {};
  const userEmail = (0, _react.useMemo)(() => (0, _utils.getContactByType)(allowedContacts, contacts, _net.SocialContactType.Email), [allowedContacts, contacts]);
  const userPhone = (0, _react.useMemo)(() => (0, _utils.getContactByType)(allowedContacts, contacts, _net.SocialContactType.PhoneNumber), [allowedContacts, contacts]);
  const userWhatsApp = (0, _react.useMemo)(() => (0, _utils.getContactByType)(allowedContacts, contacts, _net.SocialContactType.WhatsUpNumber), [allowedContacts, contacts]);
  const srcSet = (0, _react.useMemo)(() => photoUrl ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)({
    url: photoUrl,
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: 40,
      quality: 90
    }]
  })) : undefined, [photoUrl]);
  const content = (0, _react.useMemo)(() => {
    if (isLoading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {
        "data-testid": getTestId(_constants.TOP_AREA_BANNER_DIALOG_LOADER)
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h5",
        component: "h1",
        children: title != null && title !== '' ? title : translations.topAreaBannerDialogFallbackTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.DynamicFormattedMessage, {
          translatedMessage: message != null && message !== '' ? message : translations.topAreaBannerDialogFallbackMessage,
          values: {
            emphasis: emphasis(getTestId(_constants.TOP_AREA_BANNER_DIALOG_MESSAGE))
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.GreetingMessageAndContact, {
        children: [photoUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PhotoWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Image, {
            srcSet: srcSet,
            sizes: "40px"
          })
        }) : null, greetingMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.GreetingMessage, {
          shouldHaveMarginTop: !!photoUrl,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.DynamicFormattedMessage, {
            translatedMessage: greetingMessage,
            values: {
              emphasis: emphasis(getTestId(_constants.TOP_AREA_BANNER_DIALOG_GREETING_MESSAGE))
            }
          })
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Contact.Contact, {
          contact: userEmail,
          type: "email"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Contact.Contact, {
          contact: userPhone,
          type: "phone"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Contact.Contact, {
          contact: userWhatsApp,
          type: "whatsApp"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        href: relativeUrl ?? undefined,
        maxWidth: isMobile ? undefined : '330px',
        variant: "contained",
        color: "primary",
        onClick: relativeUrl == null ? onClose : undefined,
        children: linkTitle ?? translations.gotIt
      })]
    });
  }, [getTestId, greetingMessage, isLoading, isMobile, linkTitle, message, onClose, photoUrl, relativeUrl, srcSet, title, translations.gotIt, translations.topAreaBannerDialogFallbackMessage, translations.topAreaBannerDialogFallbackTitle, userEmail, userPhone, userWhatsApp]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BannerDialog, {
    open: open,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      "data-testid": getTestId(_constants.TOP_AREA_BANNER_DIALOG),
      children: content
    })
  });
};
exports.TopAreaBannerDialog = TopAreaBannerDialog;